/* eslint-disable max-len */
import React, { useContext, useRef, useState , useEffect} from 'react'
import GlobalContext from '../../../../components/Context/GloablContext';
import { useLocation } from 'react-router-dom';
import Emptyscreenwithouttitle from '../../../../components/Emptyscreenwithouttitle';
import CustomOverLay from '../../../../components/CustomOverLay';
// import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import formatMobileNumber from '../../../../CommonMethods/FormatMobileNumber';
import { motion } from 'framer-motion';
import { useUpdatePatientAlertsMutation } from '../../../../features/patientSlice';
import AlertToggleCell from '../../../../components/AlertToggleCell';

function PatientTable({user_id,patientAssociatedTrigger,data,status,isFetching,changeProviderAccess,providerData,setChangeProviderAccess,setIsAnyFieldFilled,sendAlert,setSendAlert,setIsProviderAddOrDelete,handleDeleteAssociatedPatient,
    fetchPageAndLimit,
    queryParams,
    setQueryParams,
    pageItems,
    setPageItems
}) {
    const location = useLocation()
    const {isSideBar, setToastmessage, setToastErrorMessage} = useContext(GlobalContext);
    const [isColumnSelect, setIsColumnSelect] = useState(false);
    const [limit, setLimit] = useState(15);
    const [totalPageNumber, setTotalPageNumber] = useState(1);
    const [updatePatientAlerts] = useUpdatePatientAlertsMutation()

    const handlePrevClick = () => {

        handleOnClickPageNumber(parseInt(fetchPageAndLimit().get("page_number")) - 1);
    };

    const handleNextClick = () => {
        handleOnClickPageNumber(parseInt(fetchPageAndLimit().get("page_number")) + 1);
    };
    const limitArr = [15, 30, 50, 100];
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef();
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    // useOnClickOutside(ref, () => {
    //     setIsOpen(false);
    // });

    function handleNoOfRowsClick(number) {
        setQueryParams(`?user_id=${user_id}&page_number=1&limit=${number}`);
        patientAssociatedTrigger(`?user_id=${user_id}&page_number=1&limit=${number}`)
    }

    const handleOnClickPageNumber = (pageNum) => {
        const params = fetchPageAndLimit()
        setQueryParams(`?user_id=${user_id}&page_number=${pageNum}&limit=${params.get("limit")}`);
        patientAssociatedTrigger(`?user_id=${user_id}&page_number=${pageNum}&limit=${params.get("limit")}`)
    };

    const calculateTotalPages = (totalRecords, limit) => {
        return Math.ceil(totalRecords / limit);
    };

    useEffect(() => {
        const calculatedTotalPages = calculateTotalPages(data?.total_count, fetchPageAndLimit().get("limit"));
        setTotalPageNumber(calculatedTotalPages);
    }, [data]);

    const [hoverProperties,setHoverProperties] = useState({
        'hover':'',
        'hover_index':'',
        'index_to_display_modal':''
    })
    useEffect(()=>{

        if(data!==undefined){
            setChangeProviderAccess(data?.data?.map((item)=>item?.preference_mode))
            setSendAlert(data?.data?.map((item)=>item?.send_alert))
        }
    },[data])

    useEffect(()=>{
        if(data!==undefined){
            setPageItems(data?.data?.length);
        }
    },[data])

    const handleAlertToggle = async (item, field, newValue) => {
        try {
            const response = await updatePatientAlerts({
                patient_id: item?.patient_id,
                body: {
                    user_id: user_id,
                    user_type: 'provider',
                    [field]: newValue
                }
            })
            if (response?.error) {
                setToastErrorMessage(response?.error?.data?.message || 'Something went wrong. Please try again')
                return false
            } else {
                setToastmessage('Alert setting updated successfully')
                return true
            }
        } catch {
            setToastErrorMessage('Something went wrong. Please try again')
            return false
        }
    }

    return (
        <>
            <div className='overflow-auto scrollbar_purple pb-2.5'>
                {data?.data && data?.data.length === 0
                    ? <Emptyscreenwithouttitle customHeight={true} FirstPTag={"No patients linked yet"} />
                    :
                    <>
                        { ((isFetching&&status!=="fulfilled"&&status!=="rejected")||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Patient List..." classKey={` top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened_sidebar_overlay2':'overlay-list2'}`}/>: <>
                            <table aria-label="Outside Table" className="w-full table-auto">
                                <thead>
                                    <tr className="w-full bg-[#EDD7E1] rounded-sm sticky top-[0px] left-0 z-[1]">
                                        <th className="px-[18px] py-2 rounded-tl-sm rounded-bl-sm min-w-[100px] text-start">
                                            <span htmlFor="top-id" className="text-sm font-normal text-[#031624] w-full cursor-pointer">Patient ID</span>
                                        </th>
                                        <th id="firstName" className="px-[18px] py-2 min-w-[140px]">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000] ">First Name
                                            </span>
                                        </th>
                                        <th id="middleName" className="px-[18px] py-2 min-w-[180px]">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]" >Middle Name
                                            </span>
                                        </th>
                                        <th id="lastName" className="px-[18px] py-2 min-w-[150px]">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Last Name
                                            </span>
                                        </th>
                                        <th className="px-[18px] py-2 min-w-[150px]">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Date of Birth
                                            </span>
                                        </th>
                                        <th className="px-[18px] py-2 min-w-[130px] text-start">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Primary Identifier</span>
                                        </th>
                                        <th className="px-[18px] py-2 min-w-[150px] text-start">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Secondary Identifier</span>
                                        </th>
                                        <th className="px-[18px] py-2 min-w-[150px]">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Username</span>
                                        </th>
                                        <th className="px-[18px] py-2 min-w-[200px] text-start">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Organization <br /> Name</span>
                                        </th>
                                        <th className="px-[18px] py-2 min-w-[200px] text-start">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Sub Division <br /> Name</span>
                                        </th>
                                        <th className="px-[18px] py-2 min-w-[130px]">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Alerts by SMS</span>
                                        </th>
                                        <th className="px-[18px] py-2 min-w-[130px]">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Alerts by Email</span>
                                        </th>
                                        <th className="px-[18px] py-2 min-w-[180px] whitespace-nowrap">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Include Missed Readings</span>
                                        </th>
                                        <th className="px-[18px] py-2 rounded-tr-[2px] rounded-br-[2px] sticky top-0 right-[286px] bg-[#EDD7E1] min-w-[120px] text-start">
                                            <span className="flex items-center justify-center text-sm font-normal text-[#000000]">Send Alert
                                            </span>
                                        </th>
                                        <th className="px-[18px] py-2 rounded-tr-[2px] rounded-br-[2px] sticky top-0 right-[125px] bg-[#EDD7E1] min-w-[110px] text-start">
                                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Preference Mode
                                            </span>
                                        </th>
                                        <th className="px-[18px] py-2 rounded-tr-[2px] rounded-br-[2px] sticky top-0 right-[0px] bg-[#EDD7E1] min-w-[125px]">
                                            <span className="flex items-center justify-center text-sm font-normal text-[#000000]">Remove
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data!==undefined&&data?.data?.map((item,index)=>{
                                        return(<tr key={index}>
                                            <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px] prevent-click">
                                                {item?.patient_id}
                                            </td>
                                            <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{item?.patientData?.first_name}</td>
                                            <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{item?.patientData?.middle_name===""?"-":item?.patientData?.middle_name}</td>
                                            <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{item?.patientData?.last_name}</td>
                                            <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{item?.patientData?.date_of_birth}</td>
                                            <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{item?.patientData?.primary_identifier}</td>
                                            <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{item?.patientData?.secondary_identifier===""? "-" : item?.patientData?.secondary_identifier}</td>
                                            <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{item?.patientData?.user_name}</td>
                                            <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{item?.patientData?.organization_name}</td>
                                            <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{item?.patientData?.subdivision_name}</td>
                                            <AlertToggleCell
                                                initialValue={item?.sms_alert === true}
                                                disabled={!providerData?.main_number || providerData?.main_number?.trim() === ""}
                                                id={`${index}providersms`}
                                                onToggle={(newValue) => handleAlertToggle(item, 'sms_alert', newValue)}
                                            />
                                            <AlertToggleCell
                                                initialValue={item?.email_alert === true}
                                                disabled={false}
                                                id={`${index}provideremail`}
                                                onToggle={(newValue) => handleAlertToggle(item, 'email_alert', newValue)}
                                            />
                                            <AlertToggleCell
                                                initialValue={item?.missed_reading_alert === true}
                                                disabled={false}
                                                id={`${index}providermissed`}
                                                onToggle={(newValue) => handleAlertToggle(item, 'missed_reading_alert', newValue)}
                                            />
                                            <td className="px-[20px] py-2 text-sm text-start font-normal text-[#031624] sticky top-0 right-[286px] bg-[#F7F7F7]">  <div className="status custom-toggle flex items-center ">
                                                <label className="switch" style={{marginLeft: '10px'}}>
                                                    <input type="checkbox"  onChange={(e)=>{
                                                        setSendAlert((prev)=>([...prev.slice(0,index),!sendAlert[index],...prev.slice(index+1)])),setIsAnyFieldFilled(true)
                                                    }} checked={sendAlert[index]} /><span id={`${index}send`} className="slider round"></span>
                                                </label></div></td>
                                            <td className={`px-[18px] py-2 text-sm text-start font-normal bg-[#F7F7F7] text-[#031624] sticky top-0 right-[125px]`}>
                                                <div className={`border border-[#C5C9DA] ${!sendAlert[index]?'bg-[#E7EAF4]':''} rounded-[16px] p-1 w-max`}>
                                                    <button id={`${index}email`} disabled={(!sendAlert[index]||(providerData?.email_address===""))} onClick={()=>{setChangeProviderAccess((prev)=>([...prev.slice(0,index),"email",...prev.slice(index+1)])),setIsAnyFieldFilled(true)}} className={`px-3 py-1.5 text-sm font-semibold text-[#777C88] rounded-[12px] mr-1 ${changeProviderAccess[index]==="email"?(!sendAlert[index]?'bg-[#777C88] text-[#C5C9DA] !important':'bg-[#008586] text-[#FFFFFF] !important'):''}}`}>
                                                        Email
                                                    </button>
                                                    <button disabled={(!sendAlert[index]||(providerData?.mobile_number===""))} onClick={()=>{setChangeProviderAccess((prev)=>([...prev.slice(0,index),"call",...prev.slice(index+1)])),setIsAnyFieldFilled(true)}} className={`px-3 py-1.5 text-sm font-semibold text-[#777C88] rounded-[12px] ${changeProviderAccess[index]==="call"?(!sendAlert[index]?'bg-[#777C88] text-[#C5C9DA] !important':'bg-[#008586] text-[#FFFFFF] !important'):''}`}>
                                                        Call
                                                    </button>
                                                </div>
                                            </td>
                                            <td onMouseEnter={()=>{setHoverProperties((prev)=>({...prev,hover:'modify',hover_index:index}))}}
                                                onMouseLeave={()=>{setHoverProperties((prev)=>({...prev,hover:'',hover_index:null}))}} className="px-[12px] py-2 bg-[#F7F7F7] text-sm text-center font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px] sticky top-0 right-0">

                                                {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index ))?<>
                                                    <motion.div
                                                        initial={{ opacity: 1, x: 0,y:0 }}
                                                        animate={{ opacity: 1, x: -40 ,y:0}}
                                                        transition={{ delay: 0.2, duration: 0.5 }}
                                                        exit={{ opacity: 0,x:0,transition: { duration: 0.5 ,delay:0.9} }}
                                                        className=''
                                                    >
                                                        <button id="link_patient" onClick={()=>{handleDeleteAssociatedPatient(item,index)}}>
                                                            <img loading='lazy' decoding='async' src="/images/deleteicon-pink.svg" className="mx-auto w-5 mr-3" alt="icon" />
                                                        </button>
                                                    </motion.div>

                                                </>: <button id="link_patient"  onClick={()=>{handleDeleteAssociatedPatient(item,index)}}>
                                                    <img loading='lazy'  decoding='async' src="/images/deleteicon-pink.svg" className="mx-auto w-5 mr-3" alt="icon" />
                                                </button>}
                                                {((hoverProperties.hover === 'modify' && (hoverProperties.hover_index === index))||(hoverProperties.index_to_display_modal === index )) &&
                                                <motion.div
                                                    initial={{ opacity: 0, x: 0,y:0 }}
                                                    animate={{ opacity: 1, x: 0 ,y:0}}
                                                    transition={{ delay: 0.2, duration: 0.5 }}
                                                    exit={{ opacity: 0,x:0,transition: { duration: 0.5 ,delay:0.9} }}
                                                    className=''
                                                >

                                                    <div className='relative ml-2 cursor-pointer mt-[-25px]' onClick={()=>{handleDeleteAssociatedPatient(item,index),setIsProviderAddOrDelete(true)}} >

                                                        <p className="text-sm  font-normal text-[#972E4C] ">Remove</p>

                                                    </div>
                                                </motion.div>

                                                }
                                            </td>
                                        </tr>)})}
                                </tbody>
                            </table>
                        </>}
                    </>
                }
            </div>
            {data && data?.total_count>15 &&
                <div className="w-[100%] px-2.5 pt-0 flex items-center justify-between bg-[#F4F7FC]">
                    <p className="text-sm font-semibold text-[#687182]">
                        Total Number of Records: {data?.total_count}
                    </p>
                    <div className="flex items-center">
                        <div className={`${isColumnSelect ? 'pl-1' : 'relative pl-1'}`}>
                            <button
                                ref={buttonRef}
                                onClick={() => setIsOpen(!isOpen)}
                                type="button"
                                className="text-sm font-semibold text-[#687182] flex items-center"
                            >
                                <p>Rows per page: {fetchPageAndLimit().get("limit")}</p>
                                <span className="pl-0.5">
                                    <img
                                        src="/images/down.svg"
                                        className={`${isOpen ? "transform rotate-180" : ""}`}
                                        alt="icon"
                                        onClick={() => setIsOpen(!isOpen)}
                                    />
                                </span>
                            </button>
                            <ul
                                className={`absolute top-[-140px] left-[96px] pl-1.5 py-1.5 pr-0.5 z-[9999] bg-white border border-white h-fit rounded-sm shadow-xl ${isOpen ? "" : "hidden"}`}
                                ref={dropdownRef}
                            >
                                <li>
                                    <ul className="max-h-[110px] overflow-auto pr-2 bg-white scrollbar_gray_thin ">
                                        {limitArr.map((item, index) => (
                                            <li key={index}>
                                                <h1
                                                    onClick={() => {
                                                        setLimit(item);
                                                        setIsOpen(false);
                                                        handleNoOfRowsClick(item);
                                                    }}
                                                    className={`text-base font-normal cursor-pointer ${
                                                        item === parseInt(limit) ? "text-[#008586]" : "text-[#00000]"
                                                    } mb-[16px]`}
                                                >
                                                    {item}
                                                </h1>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className="flex items-center ml-5">
                            <button
                                disabled={parseInt(fetchPageAndLimit().get("page_number")) === 1}
                                onClick={handlePrevClick}
                                className="px-1 py-0.5 border-2 border-[#687182] rounded-md"
                            >
                                <img src="/images/left.svg" alt="icon" />
                            </button>
                            <p className="text-sm font-semibold text-[#687182] mx-2.5">
                                <span className="text-[#171C26]">{fetchPageAndLimit().get("page_number")}</span>/{totalPageNumber}
                            </p>
                            <button
                                disabled={parseInt(fetchPageAndLimit().get("page_number")) === totalPageNumber}
                                onClick={handleNextClick}
                                className="px-1 py-0.5 border-2 border-[#687182] rounded-md"
                            >
                                <img src="/images/right.svg" alt="icon" />
                            </button>
                        </div>
                    </div>
                </div>}
        </>


    )
}

export default PatientTable